<template>
  <v-row>
    <v-col cols="12" lg="6" md="6" sm="12" xs="12">
      <v-autocomplete
        id="edit-event-day-select"
        :label="$t('EVENTFORM.form.day')"
        :rules="[(v) => !!v || $t('EVENTFORM.form_validation.day')]"
        required
        :prepend-inner-icon="icons.mdiCalendar"
        :items="eventDates"
        outlined
        v-model="schedule.day"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" lg="3" md="3" sm="6" xs="6">
      <v-menu
        ref="menuStart"
        v-model="menuStart"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="schedule.start"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            id="edit-event-time-start-time-picker"
            v-model="schedule.start"
            :label="$t('EVENTFORM.form.start')"
            :rules="[(v) => !!v || $t('EVENTFORM.form_validation.start')]"
            :prepend-inner-icon="icons.mdiClockTimeFourOutline"
            readonly
            outlined
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="menuStart"
          v-model="schedule.start"
          full-width
          @click:minute="$refs.menuStart.save(schedule.start)"
          :max="maxTime"
        ></v-time-picker>
      </v-menu>
    </v-col>
    <v-col cols="12" lg="3" md="3" sm="6" xs="6">
      <v-menu
        ref="menuEnd"
        v-model="menuEnd"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="schedule.end"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            id="edit-event-time-end-time-picker"
            v-model="schedule.end"
            :label="$t('EVENTFORM.form.end')"
            :rules="[(v) => !!v || $t('EVENTFORM.form_validation.end')]"
            :prepend-inner-icon="icons.mdiClockTimeFourOutline"
            readonly
            outlined
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="menuEnd"
          v-model="schedule.end"
          full-width
          @click:minute="$refs.menuEnd.save(schedule.end)"
          :min="minTime"
        ></v-time-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import { mdiClockTimeFourOutline, mdiCalendar } from "@mdi/js";

export default {
  props: ["schedule"],
  data() {
    return {
      icons: {
        mdiClockTimeFourOutline,
        mdiCalendar
      },
      eventDates: ["2021-09-08", "2021-09-09", "2021-09-10"],
      menuStart: false,
      menuEnd: false
    };
  },
  computed: {
    start() {
      return this.schedule.start;
    },
    end() {
      return this.schedule.end;
    },
    minTime() {
      if (!this.start) {
        return '00:30';
      }

      const parts = this.start.split(/:/);
      const hour = parseInt(parts[0]);
      const minute = parseInt(parts[1]);

      let hourEnd = '';
      let minuteEnd = '';

      if (minute < 30) {
        hourEnd = hour.toString();
        minuteEnd  = (minute + 30).toString();
      } else {
        hourEnd = (hour + 1).toString();
        minuteEnd = (minute - 30).toString();
      }

      return `${hourEnd}:${minuteEnd}`;
    },
    maxTime() {
      if (!this.end) {
        return '23:30';
      }

      const parts = this.end.split(/:/);
      const hour = parseInt(parts[0]);
      const minute = parseInt(parts[1]);

      let hourStart = '';
      let minuteStart = '';

      if (minute >= 30) {
        hourStart = hour.toString();
        minuteStart  = (minute - 30).toString();
      } else {
        hourStart = (hour - 1).toString();
        minuteStart = (30 + minute).toString();
      }

      return `${hourStart}:${minuteStart}`;
    }
  }
};
</script>